import React from 'react';
import Link from '@material-ui/core/Link';

interface Props {
  text?: React.ReactNode;
  link: string;
}

function HelpArticleLink({ link, text = 'Show me how ❯' }: Props) {
  return (
    <Link
      href={link}
      variant={'body2'}
      color={'secondary'}
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
    </Link>
  );
}

export default HelpArticleLink;
